import { RootAppState } from 'store/configureStore'

export const projectQuantitySelector = (state: RootAppState) =>
  state.project.activeProject?.financial.quantity
